module.exports = __webpack_public_path__ + "static/media/easi6_booking_ko.c2a92812.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_booking_ko.md
// module id = 50
// module chunks = 0